import React from 'react'
import styled from 'styled-components';


export const ContentWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  padding: 150px 200px 0;
  background-color: #dedede;
  background-image: linear-gradient(#ecebeb 50%, transparent 50%, transparent);
  background-size: 5px 5px;
`;


export default ContentWrapper